import React, { useEffect, useMemo } from "react"
import { Outlet, Route, Routes } from "react-router-dom"
import Synthese from "components/transactions/Synthese"
import CreditDemands from "components/transactions/CreditDemands"
import NavTabs from "components/common/nav-tabs/NavTabs"
import { TRANSACTIONS_URL } from "@/constants/mainRoutes"
import { useAppDispatch, useAppSelector } from "@/hooks/reduxToolkitHook"
import { fetchTransactions } from "@/redux/features/transactionsSlice"
import NotificationBadge from "components/common/notifications/NotificationBadge"
import { WalletTransaction } from "@/types/TransactionsType"

function Transactions() {
  const dispatch = useAppDispatch()
  const { transactions, transactionsStatus } = useAppSelector(state => state.transactions)

  useEffect(() => {
    if (transactionsStatus === "idle") {
      dispatch(fetchTransactions())
    }
  }, [transactionsStatus])

  const pendingTransactionsCount = useMemo(() => {
    return transactions.filter(
      (tx: WalletTransaction) => tx.needs_validation,
    ).length
  }, [transactions])

  const navItems = [
    { link: "", value: "Synthèse" },
    {
      link: "recharge",
      value: <div className="flex space-x-3 items-center">
        <span>Demandes de rechargement</span> {pendingTransactionsCount && <NotificationBadge notification={{
        type: "danger" as const,
        count: pendingTransactionsCount,
        pulse: false,
      }} />
      }</div>,
    },
  ]

  return (
    <div className="py-2 px-4 space-y-2">
      <div className="bg-white pt-2 px-2 mb-5 rounded-lg">
        <NavTabs navItems={navItems} baseRoute={TRANSACTIONS_URL} className="gap-7 " />
      </div>

      <div className=" space-y-6">
        <Routes>
          <Route index element={<Synthese />} />
          <Route path="recharge" element={<CreditDemands />} />
        </Routes>
      </div>
      <Outlet />
    </div>
  )

}


export default Transactions
